import { createAction, props } from '@ngrx/store';

export const CERTIFICA_EMAIL = createAction(
  '[CERTIFICA EMAIL] - submit',
  props<{ body: { email: string } }>()
);

export const CERTIFICA_EMAIL_SUCCESS = createAction(
  '[CERTIFICA EMAIL] - success',
  props<{ 
    esito: string;
    seed: string;
    email: string;
    msgCode?: string;
    otpTtlSeconds?: number;
    otpTtlSecondsEmail?: number;
    coolDownOTP?: number;
    maxTentativi?: number;
  }>()
);

export const CERTIFICA_EMAIL_FAIL = createAction(
  '[CERTIFICA EMAIL] - fail',
  props<{ error: any }>()
);

export const CERTIFICA_EMAIL_RESET = createAction(
  '[CERTIFICA EMAIL] - reset'
);


export const CERTIFICA_OTP = createAction(
  '[CERTIFICA EMAIL] - submit otp',
  props<{ 
    otp: string; 
    seed: string; 
    username: string;
    telefono_certificato?: string | null;
  }>()
);

export const CERTIFICA_OTP_SUCCESS = createAction(
  '[CERTIFICA EMAIL] - otp success',
  props<{ 
    esito: string; 
    msgCode?: string;
    username: string | null;
  }>()
);

export const CERTIFICA_OTP_FAIL = createAction(
  '[CERTIFICA EMAIL] - otp fail',
  props<{ error: any }>()
);

export const CERTIFICA_EMAIL_PRELOAD = createAction(
  '[CERTIFICA EMAIL] preload',
  props<{ email: string }>()
);
